import React from 'react'

const CloseIcon = () => {
	return (
		<svg viewBox="0 0 8 9" xmlns="http://www.w3.org/2000/svg">
		  <g id="brandkit/onboarding" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
		    <g id="2-create-account" transform="translate(-1162.000000, -358.000000)">
		      <g id="nav-&amp;-bg" transform="translate(187.000000, 330.000000)">
	          <g id="cancel-btn" transform="translate(968.000000, 21.000000)">
	            <path fill="#4462C9" d="M14.8598399,13.91982 L12.0399399,11.09992 L14.8598399,8.28002 C14.9797599,8.1601 14.9797599,7.96986 14.8598399,7.8601 L14.0098399,7.0101 L10.9797399,10.0398 L7.93993993,7 L7.08993993,7.85 C6.97002003,7.96992 6.97002003,8.16016 7.08993993,8.26992 L9.90983992,11.08982 L7.09963992,13.91992 C6.97972002,14.03984 6.97972002,14.23008 7.09963992,14.33984 L7.94963992,15.1898402 L10.9797399,12.15974 L14.0195399,15.1995402 L14.8695399,14.34954 C14.9796999,14.23001 14.9796999,14.03977 14.8597749,13.91985 L14.8598399,13.91982 Z" id="Page-1"></path>
	          </g>
		      </g>
		    </g>
	   	</g>
		</svg>
	)
}

export default CloseIcon;
